import { render, staticRenderFns } from "./employment-doc-side.vue?vue&type=template&id=7faece69"
import script from "./employment-doc-side.vue?vue&type=script&lang=js"
export * from "./employment-doc-side.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports